import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../Components/Common/Breadcrumb";
import { Card, CardBody, Row, Col, Table, CardImg, CardTitle,Alert } from "reactstrap";
import { fetchCheckoutDisclaimer, CheckoutDisclaimer } from "../../../utils/checkoutDisclaimer";
import axios from "axios";
import TableContainer from "../../../Components/Common/TableContainer";
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";

interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const Cst_booking_group = () => {
    document.title = "Booking Group | BizServe";
    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };

    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const [checkoutDisclaimer, setCheckoutDisclaimer] = useState<CheckoutDisclaimer | null>(null);
    const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
    const [cartData, setCartData] = useState<any[]>([]);
    const [showloader, setshowloader] = useState(true);
    const [selectedPricePack, setSelectedPricePack] = useState<any>(null);
    const [selectedSlot, setSelectedSlot] = useState<any>(null);
    const [selectedPurpose, setSelectedPurpose] = useState<any>(null);
    const [selectedExpert, setSelectedExpert] = useState<any>(null);
    const [selectedBookingDate, setSelectedBookingDate] = useState<any>();

    const totalAmount = cartData.reduce((total, item) => total + (item.expert_price || 0), 0);

    const CheckboxChange = async (e) => {
        const newValue = e.target.checked;
        setIsTermsAccepted(newValue); 
        const isTermsAccepted = newValue; 
        console.log("Checkbox changed:", isTermsAccepted);
        try {
            console.log("Terms already accepted, no action taken.");
            const response = await axios.post('bookings/check_slot_conflicts',{isTermsAccepted : isTermsAccepted});
            console.log("check the response of CheckboxChange",response)
            if (response.status === "CONFLICT") {
                const list = response.conflicts || [];
                console.log("Slot conflicts found:", list);
                const lines = list.map((c: { detail?: string; expert_name?: string; date_display?: string; time_display?: string }, i: number) => {
                    let line = c.detail;
                    if (!line && c.expert_name) {
                        const when =
                            c.date_display && c.time_display
                                ? `${c.date_display} at ${c.time_display}`
                                : c.date_display || c.time_display || "";
                        line = when ? `${c.expert_name} — ${when}` : c.expert_name;
                    }
                    line = line || "This time slot";
                    return `${i + 1}. ${line}`;
                });
                alert(
                    [
                        "Someone else is currently holding the same appointment time for:",
                        "",
                        ...lines,
                        "",
                        "Remove or change those slots, or try again in a few minutes.",
                    ].join("\n")
                );
                setIsTermsAccepted(false);
            } else if (response.status === "HELD") {
                console.log("✅ Slots held until:", response.hold_until);
            }
        }catch (error) {
            console.error("Error checking slot conflicts:", error);
            alert("An error occurred while checking slot conflicts. Please try again.");
        }
    };

    const Get_cart_details = async () => {
        console.log("Fetching cart details...");
        setshowloader(true);
        try {
            const response = await axios.post('bookings/get_cart_details');
            console.log("Response status:", response.status);
            if (response.status === "CART_DETAILS") {
                console.log("getting cart details", response.cart_items);
                console.log("getting cart details2", response.cart_items[0]?.exp_session_mins);
                const cartItems = response.cart_items;
                localStorage.setItem('cart_length', cartItems.length.toString());
                // if (cartItems.length > 0) {
                //     if (!localStorage.getItem("expert_session_timing")) {
                //         localStorage.setItem("expert_session_timing", cartItems[0].exp_session_mins);
                //     }
                // } else {
                //     localStorage.removeItem("expert_session_timing");
                // }
                window.dispatchEvent(new Event("cartLengthUpdated"));
                setCartData(cartItems);
                setshowloader(false);
            }
        } catch (error) {
            console.error("Error fetching cart details:", error);
            setshowloader(false);
        }
    };

    useEffect(() => {
        Get_cart_details();
        fetchCheckoutDisclaimer().then(setCheckoutDisclaimer);
    }, []);

    useEffect(() => {
        localStorage.setItem('cart_length', cartData.length.toString());
        localStorage.getItem('cart_length');
    }, [cartData]);

    async function booktheexpert() {
        if (!cartData || cartData.length === 0) {
            setAlertMsgg({...alertMsgg,open: true, content: "Please add at least one expert before proceeding.",type: "warning",});
            setTimeout(()=>{setAlertMsgg("")}, 6000)
            return;
        }

        const data: any = { 
            user_info: localStorage.getItem('userinfo_'), 
            cartData:cartData,
            cartsidebook:"cartsi_debook"
        };
        if (checkoutDisclaimer) data.disclaimer_version_id = checkoutDisclaimer.id;
        setAlertMsgg({ ...alertMsgg, open: true, content: `Redirecting you for subscription payment.`, type: "success" })
        setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 7000);
        try {
            const response = await axios.post('payments/create_expert_checkout',data,{withCredentials:true,headers: { "Content-Type": "application/json", },});
            if (response.status === "checkout_stripe"){
                window.location.href = response.success_url
                // setshowloader(false)
            }
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            // setshowloader(false)
        }finally {
            const closeloader = document.querySelector('.loaderWeb') as HTMLElement | null;
            if (closeloader) {closeloader.style.display = 'none';}  
        }
    }

    const columns: column[] = useMemo(
        () => [
        {
            header: "Expert Details",
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }: any) => {
            const expert = row.original.expert;
            const user = expert?.user;
            const category = expert?.category?.name;
            const subcategory = expert?.subcategory?.name;

            return (
                <div className="d-flex align-items-top gap-2">
                <div>
                    <CardImg
                    className="imageExpertBookingSmall"
                    src={
                        user?.profile_pic
                        ? user?.profile_pic
                        : defaultUserImg
                    }
                    alt={user?.get_full_name || "Expert"}
                    />
                </div>
                <div className="w-100">
                    <CardBody className="position-relative pt-2 ps-0 pb-0">
                    <CardTitle
                        tag="h4"
                        className="text-primary border-start border-primary ps-2 font-size-12 fw-medium"
                    >
                        {category} ({subcategory})
                    </CardTitle>
                    <h2 className="text-capitalize font-size-15">{user?.get_full_name}</h2>
                    </CardBody>
                </div>
                </div>
            );
            },
        },
        {
            header: "Booking Date",
            accessorKey: "seldate",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Booking Duration",
            accessorKey: "hour",
            enableColumnFilter: false,
            enableSorting: true,
            cell: ({ row }: any) => {
            return <>{`${row.original?.exp_session_mins} Mins`}</>;
            },
        },
        {
            header: "Booking Slots",
            accessorKey: "timeslot",
            enableColumnFilter: false,
            enableSorting: true,
            cell: ({ row }: any) => {
            return <>{row.original?.seltimes?.hour}</>;
            },
        },
        {
            header: "Price",
            accessorKey: "expert.packs",
            enableColumnFilter: false,
            enableSorting: true,
            cell: ({ row }: any) => {
            return `$${row.original?.expert_price}`;
            },
        },
        {
            header: "Action",
            id: "action",
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }: any) => {
            const cartItemId = row.original.id;
            const handleDelete = async () => {
                console.log(" Delete ID:", cartItemId);
                const response = await axios.post('bookings/delete_cart_item', { cart_item_id: cartItemId });
                console.log("Response from delete:", response);
                if (response.status === "CART_ITEM_DELETED"){
                    Get_cart_details();
                    setAlertMsgg({ open: true, content: "Cart item deleted successfully.", type: "success" });
                    setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));}, 4000);
                }
            };
            return (
                <div className="d-flex gap-2">
                <button className="btn btn-danger btn-sm" onClick={handleDelete}>
                    <i className="bx bxs-trash-alt"></i>
                </button>
                </div>
            );
            },
        },
        ],
        []
    );

    return (
        <div className="page-content">
        <div className="container-fluid">
            {alertMsgg.open && (
                <Alert 
                    color={alertMsgg.type === "success" ? "success" : "danger"} 
                    toggle={handleAlertMsggClose}
                    style={{ fontWeight: "bold" }}>
                    {alertMsgg.content}
                </Alert>
            )}
            <Breadcrumbs title="Customers" breadcrumbItem="Cart Information" />
            <Row>
            <Col md="9">
                <Card className="rounded-4 border shadow-0">
                <CardBody>
                    <div className="table-responsive">
                        <div className="loaderContainer" hidden={!showloader}>
                            <div className="spinner">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <div className="mb-3">
                            {cartData.length === 0 && (
                                <div
                                className="text-center py-4"
                                style={{
                                    background: "#fff3cd",
                                    color: "#856404",
                                    border: "1px solid #ffeeba",
                                    borderRadius: "6px",
                                    fontWeight: 500,
                                }}
                                >
                                Oops! No items found in your cart.
                                </div>
                            )}
                        </div>
                        <TableContainer
                            columns={columns}
                            data={cartData}
                            isGlobalFilter={true}
                            isPagination={true}
                            SearchPlaceholder="Search By Name..."
                            pagination="pagination"
                            paginationWrapper="dataTables_paginate paging_simple_numbers"
                            tableClass="table-bordered dt-responsive table-nowrap w-100 dataTable no-footer dtr-inline"
                        />
                    </div>
                </CardBody>
                </Card>
            </Col>

            <Col md="3">
                <Card className="rounded-4 border shadow-0">
                <CardBody className="px-3 py-4">
                    <CardTitle className="mb-3 text-center text-primary fw-bold fs-5">
                    Booking Summary
                    </CardTitle>
                    <div className="table-responsive">
                    <Table className="table mb-0 styleSettable">
                        <tbody>
                        {cartData.map((item, index) => {
                            const expertName = item.expert?.user?.get_full_name || `Booking ${index + 1}`;
                            return (
                                <tr key={index}>
                                <td>{expertName}:</td>
                                <td className="text-end">${item.expert_price}</td>
                                </tr>
                            );
                        })}
                        <tr className="fw-bold border-top">
                            <td>Total:</td>
                            <td className="text-end">${totalAmount}</td>
                        </tr>
                        </tbody>
                    </Table>
                    </div>

                    {/* <div className="text-sm-end mt-3">
                    <Link to="" className="btn btn-success w-100">
                        <i className="bx bx-calendar me-1" /> Book Now
                    </Link>
                    </div> */}
                    <div className="form-check mt-3">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="termsCheckbox"
                            checked={isTermsAccepted}
                            onChange={CheckboxChange}
                        />
                        <label className="form-check-label" htmlFor="termsCheckbox">
                            I agree to proceed with the booking.
                        </label>
                    </div>
                    {checkoutDisclaimer && (
                        <div className="form-check mt-2">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="disclaimerCheckbox"
                                checked={disclaimerAccepted}
                                onChange={(e) => setDisclaimerAccepted(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="disclaimerCheckbox">
                                {checkoutDisclaimer.text}
                            </label>
                        </div>
                    )}
                    <div className="text-sm-end mt-3">
                        {isTermsAccepted && (!checkoutDisclaimer || disclaimerAccepted) ? (
                            <Link to="" className="btn btn-success w-100" onClick={booktheexpert}>
                                <i className="bx bx-calendar me-1" /> Book Now
                            </Link>
                        ) : (
                            <button className="btn btn-success w-100" disabled>
                                <i className="bx bx-calendar me-1" /> Book Now
                            </button>
                        )}
                    </div>
                </CardBody>
                </Card>
            </Col>
            </Row>
        </div>
        </div>
    );
};

export default Cst_booking_group;
